import React, { memo, useEffect, useState, useRef } from 'react'
import SearchForm from './SearchForm'
import SearchField from '../../lib/react-storefront/search/SearchField'
import SearchProvider from '../../providers/SearchProvider'
import SearchPopover from '../../lib/react-storefront/search/SearchPopover'
import { useRouter } from 'next/router'
import SearchSuggestions from './searchComponents/SearchSuggestions'

function SearchDesktop() {
  const inputRef = useRef(null)
  const activeRef = useRef(false)
  const [query, setQuery] = useState('')
  const [input, setInput] = useState('')
  const [popoverOpen, setPopoverOpen] = useState(false)
  const router = useRouter()
  let { storeSlug } = router.query
  useEffect(() => {
    if (!activeRef.current) {
      activeRef.current = true
    }
  }, [popoverOpen])

  return (
    <SearchForm action={'/store/' + storeSlug + '/search'}>
      <SearchField
        ref={inputRef}
        onChange={value => {
          let v = value.replace(/[\/\\#+^()$~%:*?<>{}@!]/g, '')
          setQuery(v)
          setInput(v)
        }}
        value={input}
        onFocus={() => setPopoverOpen(true)}
        submitButtonVariant="none"
        showClearButton={false}
      />

      <SearchProvider store={storeSlug} query={query} active={activeRef.current}>
        <SearchPopover
          classes={{ popoverPaper: 'suggestion-box' }}
          open={popoverOpen}
          setQuery={setQuery}
          anchor={inputRef}
          onClose={() => setPopoverOpen(false)}
        >
          <SearchSuggestions />
        </SearchPopover>
      </SearchProvider>
    </SearchForm>
  )
}

export default memo(SearchDesktop)